module.exports = __webpack_public_path__ + "static/media/hero-backyard.024a48ce.jpg";